// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__wdceO","counterWrapper":"styles_counterWrapper__5FW42","touchableWrapper":"styles_touchableWrapper__VHJYU"};